// see https://github.com/mui-org/material-ui/issues/13744

import { PropTypes, StandardProps } from '@material-ui/core';
import OrgFormControl from '@material-ui/core/FormControl';
import * as React from 'react';

export interface IFormControlProps
	extends StandardProps<
		React.HtmlHTMLAttributes<HTMLDivElement>,
		FormControlClassKey
	> {
	component?: React.ReactType<IFormControlProps> | 'fieldset';
	disabled?: boolean;
	error?: boolean;
	fullWidth?: boolean;
	margin?: PropTypes.Margin;
	onBlur?: React.EventHandler<any>;
	onFocus?: React.EventHandler<any>;
	required?: boolean;
	variant?: 'standard' | 'outlined' | 'filled';
}

export type FormControlClassKey =
	| 'root'
	| 'marginNormal'
	| 'marginDense'
	| 'fullWidth';

const FormControl: React.FC<IFormControlProps> = props => (
	<OrgFormControl {...props as any} />
);

export default FormControl;



// WEBPACK FOOTER //
// ./src/utils/FormControlWrapper.tsx